import { Button } from "react-admin";
import Edit from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

const IndividualCurriculumButton = ({ record }) => {
  const navigate = useNavigate();

  if (!record?.id) return null;

  return (
    <Button
      label="Въведи индивидуален учебен план"
      variant="contained"
      startIcon={<Edit />}
      onClick={() =>
        navigate("/student/individual-curriculum", {
          state: {
            educationId: record?.id,
            facultyNumber: record?.facultyNumber,
            curriculumName: record?.curriculumName,
            course: record?.course,
          },
        })
      }
    />
  );
};

export default IndividualCurriculumButton;
